import styled, { createGlobalStyle } from "styled-components";
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import SubmitComplaint from "./components/SubmitComplaint";
import SearchComplaint from "./components/SearchComplaint";
import TrackTransport from "./components/TrackTransport";
import NavigationComponent from "./components/Navigation";
import {
  Page,
  Topbar,
  TopbarLeft,
  TopbarRight,
  BrandContainer,
  SystemInfo,
  SystemTitle,
  SystemSubtitle,
  Logo,
  QuickActions,
  QuickActionButton,
  StatusIndicator,
  HeaderBar,
  HeaderText,
  Main,
  Footer,
  Inquiries
} from "./styles/StyledComponents";

/**
 * ⚠️ NOTE FOR REVIEWERS
 * ---------------------
 * • This file has been refactored to use React Router for navigation.
 * • Each tab is now a separate route with its own component.
 * • All business logic and API calls remain intact in individual components.
 */

const GlobalStyle = createGlobalStyle`
  :root{
    --brand:#1d2d50;
    --brand-2:#287bc2;
    --accent:#e1523e;
    --danger:#c2284c;
    --ok:#2b9d74;
    --ink:#1a1f36;
    --muted:#6b7280;
    --card:#ffffff;
    --bg:#f6f7fb;
    --border:#e5e7eb;
    --error:#d21b4c;
    --success:#10b981;
    --warning:#f59e0b;
    --info:#3b82f6;
  }
  html, body, #root { height: 100%; }
  body{
    font-family: 'Almarai', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
    background: var(--bg);
    color: var(--ink);
    margin: 0;
    direction: rtl;
    font-weight: 400;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  *{ box-sizing: border-box; }
  .App { direction: rtl; }
`;

function App() {
  return (
    <Router>
    <div className="App">
      <GlobalStyle />
      <Page>
        <Topbar>
            <TopbarLeft>
              <BrandContainer>
                <Logo src="/images/logo.svg" alt="Tatweer Transit" />
                <SystemInfo>
                  <SystemTitle>شركة تطوير لخدمات النقل</SystemTitle>
                  <SystemSubtitle>نظام إدارة البلاغات والشكاوى</SystemSubtitle>
                </SystemInfo>
              </BrandContainer>
            </TopbarLeft>
            
          <TopbarRight>
              <StatusIndicator>النظام متاح</StatusIndicator>
              <QuickActions>
                <QuickActionButton 
                  onClick={() => window.open('tel:8001231000', '_self')}
                  title="اتصل بنا"
                >
                  8001231000
                </QuickActionButton>
              </QuickActions>
          </TopbarRight>
        </Topbar>

        <HeaderBar>
          <HeaderText>نظام البلاغات</HeaderText>
        </HeaderBar>

        <Main>
            <NavigationComponent />
            <Switch>
              <Route exact path="/" component={TrackTransport} />
              <Route path="/submit" component={SubmitComplaint} />
              <Route path="/search" component={SearchComplaint} />
            </Switch>
        </Main>

        <Footer>
       
          <div>شركة تطوير لخدمات النقل "رافد" © 2025</div>
        </Footer>
      </Page>
    </div>
    </Router>
  );
}

export default App;
